import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {BaseModule} from '../../base/base.module';
import {TranslateModule} from '@ngx-translate/core';
import {MatDialogActions, MatDialogContent, MatDialogTitle} from '@angular/material/dialog';
import {MatButtonModule} from '@angular/material/button';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {AddOrUpdateBusinessComponent} from './add-or-update-business/add-or-update-business.component';
import {AddOrUpdateRoleComponent} from './add-or-update-role/add-or-update-role.component';
import {AddOrUpdateUserComponent} from './add-or-update-user/add-or-update-user.component';
import {AttributeSelectorComponent} from './attribute-selector/attribute-selector.component';
import {AddOrUpdateAttributeComponent} from './add-or-update-attribute/add-or-update-attribute.component';
import {AddOrUpdateAttributeTypeComponent} from './add-or-update-attribute-type/add-or-update-attribute-type.component';
import {AddOrUpdateCategoryComponent} from './add-or-update-category/add-or-update-category.component';
import {AddOrUpdateServicesComponent} from './add-or-update-services/add-or-update-services.component';
import {AddOrUpdateTagComponent} from './add-or-update-tag/add-or-update-tag.component';
import {AddOrUpdateAdditiveComponent} from './add-or-update-additive/add-or-update-additive.component';
import {AddOrUpdateSpacesComponent} from './add-or-update-spaces/add-or-update-spaces.component';
import {ChairsComponent} from './chairs/chairs.component';
import {QrCodeComponent} from './qr-code/qr-code.component';
import {DetailsComponent} from './details/details.component';
import {FactorDetailComponent} from './factor-detail/factor-detail.component';
import {MatIcon} from '@angular/material/icon';
import {ChooserComponent} from './chooser/chooser.component';
import {FeaturesDialogComponent} from './features/features.component';
import {CommentDetailsComponent} from './comment-details/comment-details.component';
import {MatTableModule} from '@angular/material/table';
import {MatInputModule} from '@angular/material/input';
import {MatFormFieldModule} from '@angular/material/form-field';
import {FormsModule} from '@angular/forms';
import {AddOrUpdateSettingsComponent} from './add-or-update-settings/add-or-update-settings.component';

@NgModule({
  declarations: [
    AddOrUpdateBusinessComponent,
    AddOrUpdateRoleComponent,
    AddOrUpdateUserComponent,
    AttributeSelectorComponent,
    AddOrUpdateAttributeComponent,
    AddOrUpdateAttributeTypeComponent,
    AddOrUpdateCategoryComponent,
    AddOrUpdateServicesComponent,
    AddOrUpdateTagComponent,
    AddOrUpdateAdditiveComponent,
    AddOrUpdateSpacesComponent,
    ChairsComponent,
    QrCodeComponent,
    DetailsComponent,
    FactorDetailComponent,
    ChooserComponent,
    FeaturesDialogComponent,
    CommentDetailsComponent,
    AddOrUpdateSettingsComponent
  ],
  imports: [
    CommonModule,
    BaseModule,
    TranslateModule,
    MatDialogContent,
    MatDialogActions,
    MatDialogTitle,
    MatButtonModule,
    MatProgressSpinnerModule,
    MatIcon,
    MatTableModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule
  ]
})
export class DialogModule {
}
